/**
 * Generic debounce hook
 * Returns a value that only updates after a specified delay
 */

import { useState, useEffect } from 'react'

/**
 * Debounce a value by the given delay in milliseconds.
 * The returned value updates only after the caller stops changing `value`
 * for at least `delay` ms.
 */
export function useDebouncedValue<T>(value: T, delay: number): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value)

  useEffect(() => {
    const handler = setTimeout(() => setDebouncedValue(value), delay)
    return () => clearTimeout(handler)
  }, [value, delay])

  return debouncedValue
}
